// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderInfoMobileActions_wrapper__Lbjdx"};